import gql from 'graphql-tag'

export const UPLOAD_ENTITY_EDIT_ATTRIBUTE = gql`
  mutation update_entity_attribute(
    $id: ID!
    $vendor: String!
    $attributes: JSON
    $geom: Geom
    $ts: String
  ) {
    update_entity_attribute(
      id: $id
      vendor: $vendor
      attributes: $attributes
      geom: $geom
      ts: $ts
    ) {
      id
      attributes
      geom
    }
  }
`
